import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import "../styles/landing.css";
import PublicNavbar from "./Publicnavbar";

/* ---- Change these to match your real routes ---- */
const ROUTES = {
  professionalExplore: "/signup",
  professionalLogin: "/login",
  schoolExplore: "/signup",
  schoolLogin: "/login", 
};

const CONTACT = {
  email: "mockqofficial@gmail.com",
  phoneLabel: "8921-388584",
  phoneHref: "tel:8921388584",
};

const CARDS = [
  {
    key: "pro",
    title: "Professional",
    text: "Full-length mock exams that match the original paper, with AI proctoring on every attempt.",
    chips: ["CMA USA", "ACCA", "EA"],
    mini: [
      ["CMA USA · Mock 3", "01:42:18"],
      ["AI proctor", "Active"],
    ],
    explainLabel: "Explore professional",
    explore: ROUTES.professionalExplore,
    login: ROUTES.professionalLogin,
  },
  {
    key: "sch",
    title: "School, Class 5 to 12",
    text: "Chapter-wise practice and timed exams for every subject, with progress reports for parents.",
    chips: ["Class 5–12"],
    mini: [
      ["Class 7 · Science", "3 correct in a row"],
      ["Plan", "Monthly, quarterly, yearly"],
    ],
    explainLabel: "Explore school",
    explore: ROUTES.schoolExplore,
    login: ROUTES.schoolLogin,
  },
];

const COMPARE_ROWS = [
  [
    "Who it is for",
    "Candidates preparing for CMA USA, ACCA or EA",
    "Students from Class 5 to Class 12",
  ],
  [
    "What you do",
    "Sit full mock exams in the real exam format, with AI proctoring",
    "Practise chapter by chapter, then take timed exams",
  ],
  [
    "How you pay",
    "Pay for the exams you take",
    "Monthly, quarterly or yearly subscription",
  ],
  [
    "You get",
    "A scored result and section-wise performance",
    "Scores by subject and a parent progress report",
  ],
];

function SearchArt() {
  return (
    <svg className="art" viewBox="0 0 200 200" aria-hidden="true">
      <circle cx="100" cy="100" r="70" strokeWidth="22" />
      <path d="M148 148 L184 184" strokeWidth="22" />
      <path d="M58 142 Q104 132 124 76" strokeWidth="12" />
      <polygon points="106,72 140,56 144,94" />
    </svg>
  );
}

export default function Landing() {
  const location = useLocation();

  // Handles "Contact" / "Compare" clicked from another page
  useEffect(() => {
    const id = location.state?.scrollTo;
    if (!id) return;
    const t = setTimeout(() => {
      document
        .getElementById(id)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
    return () => clearTimeout(t);
  }, [location.state]);

  return (
    <div className="mq-theme landing-page">
      <PublicNavbar />

      <div className="mq-wrap">
        <header className="intro">
          <h1>
            One platform. <em>Two ways</em> to prepare.
          </h1>
          <p>
            Whether you are sitting a professional qualification or practising
            for school exams, MockQ gives you exams that feel like the real
            thing.
          </p>
        </header>

        <div className="split">
          {CARDS.map((c) => (
            <article className={`pc ${c.key}`} key={c.key}>
              <SearchArt />
              <h2>{c.title}</h2>
              <p>{c.text}</p>

              <div className="chips">
                {c.chips.map((chip) => (
                  <span key={chip}>{chip}</span>
                ))}
              </div>

              <div className="mini">
                {c.mini.map(([label, value]) => (
                  <div key={label}>
                    <span>{label}</span>
                    <i>{value}</i>
                  </div>
                ))}
              </div>

              <div className="acts">
                <Link className="go" to={c.explore}>
                  {c.explainLabel}
                </Link>
                <Link className="lo" to={c.login}>
                  Log in
                </Link>
              </div>
            </article>
          ))}
        </div>

        <section id="compare">
          <h2 className="t">Which one is for me?</h2>
          <div className="tw">
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>Professional</th>
                  <th>School</th>
                </tr>
              </thead>
              <tbody>
                {COMPARE_ROWS.map(([label, pro, school]) => (
                  <tr key={label}>
                    <th>{label}</th>
                    <td>{pro}</td>
                    <td>{school}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <div id="contact">
          <div className="contact">
            <div>
              <h2>Not sure where to start?</h2>
              <p>Write or call us and we will point you to the right plan.</p>
            </div>
            <div>
              <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
              <a href={CONTACT.phoneHref}>{CONTACT.phoneLabel}</a>
            </div>
          </div>

          <footer>© 2026 MockQ. Practice. Prepare. Succeed.</footer>
        </div>
      </div>
    </div>
  );
  
}